/**
 * Adds files to `formData` the way the backend reads attachments:
 * `attachments[0]`, `attachments[1]`… each under its file name, or an empty
 * `attachments` when there are none. `files` are File/Blob objects or
 * { file, filename } (as usePickedFiles().ready() gives them). Returns
 * `formData`.
 */
export const appendFiles = (formData, files = [], field = "attachments") => {
  const list = Array.isArray(files) ? files.filter(Boolean) : [];
  if (!list.length) {
    formData.append(field, []);
    return formData;
  }
  list.forEach((entry, index) => {
    const file = entry?.file ?? entry;
    const filename = entry?.filename ?? file?.name ?? `file-${index + 1}`;
    formData.append(`${field}[${index}]`, file, filename);
  });
  return formData;
};
